module.exports = __webpack_public_path__ + "static/media/banner.8cb38f40.jpg";